/**
 * Created by maximus on 14.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactKeydown = require('react-keydown');

var _reactKeydown2 = _interopRequireDefault(_reactKeydown);

var _reactFavicon = require('react-favicon');

var _reactFavicon2 = _interopRequireDefault(_reactFavicon);

var _headInfo = require('redux/actions/headInfo');

var _helpers = require('helpers');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Header: {
        displayName: 'Header'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Header/Header.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Header = _wrapComponent('Header')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.auth.user,
        show_404: state.error.is_show_404,
        settings: state.setting,
        isShowSideMenu: state.headInfo.isShowSideMenu,
        pageList: state.page.list,
        lang: state.lang
    };
}, { showSideMenu: _headInfo.showSideMenu, hideSideMenu: _headInfo.hideSideMenu }), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Header, _Component);

    function Header(props) {
        (0, _classCallCheck3.default)(this, Header);

        // this.state = {
        //     hamburgerShow: false
        // };
        var _this = (0, _possibleConstructorReturn3.default)(this, (Header.__proto__ || (0, _getPrototypeOf2.default)(Header)).call(this, props));

        _this.handleClick = function (e) {
            //this.state.hamburgerShow ? this.setState({hamburgerShow: false}) : this.setState({hamburgerShow: true});
            var _this$props = _this.props,
                isShowSideMenu = _this$props.isShowSideMenu,
                hideSideMenu = _this$props.hideSideMenu,
                showSideMenu = _this$props.showSideMenu;

            isShowSideMenu ? hideSideMenu() : showSideMenu();
        };

        return _this;
    }

    /**
     * Обработчик показа/скрытия гамбургера
     * @param e
     */


    (0, _createClass3.default)(Header, [{
        key: 'render',


        // @keydown('Esc')
        // submit(event) {
        //     const {hamburgerShow} = this.state;
        //     if (hamburgerShow && event.which === 27) {
        //         this.handleClick();
        //     }
        // }

        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('Header'),
                _props = this.props,
                isShowSideMenu = _props.isShowSideMenu,
                user = _props.user,
                lang = _props.lang,
                _props$settings = this.props.settings,
                favicon = _props$settings.favicon,
                logo = _props$settings.logo,
                operationMode = _props$settings.operationMode,
                operationModeShow = _props$settings.operationModeShow,
                phone = _props$settings.phone,
                phoneShow = _props$settings.phoneShow,
                shopName = _props$settings.shopName;


            var pages = [];

            this.props.pageList.forEach(function (page) {
                if (page.show_in_header) {
                    pages.push({
                        title: page.title,
                        url: page.url_pages,
                        position: page.position
                    });
                }
            });

            var params = {
                logo: logo === 'default' || logo === undefined ? '' : logo,
                operationMode: operationMode,
                operationModeShow: operationModeShow,
                pages: pages,
                phone: phone,
                phoneShow: phoneShow,
                user: user,
                show: isShowSideMenu,
                title: shopName,
                handleClick: this.handleClick,
                lang: lang
            };

            return _react3.default.createElement(
                'div',
                { className: 'Header' },
                _react3.default.createElement(View, params),
                _react3.default.createElement(_components2.Hamburger, params)
            );
        }
    }]);
    return Header;
}(_react2.Component), _class2.propTypes = {
    user: _react2.PropTypes.object,
    settings: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {
    settings: {}
}, _temp)) || _class));

exports.default = Header;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.jsx
// module id = 1674
// module chunks = 0